<template>
  <v-app>
    <loader />
    <NavigationBar v-if="showNav" @toggle-drawer="toggleDrawer" />
    <NavigationDrawer v-if="showNav" :drawer-open="drawerOpen" @close-drawer="closeDrawer" />
    <v-main class="safe-area-v-main">
      <router-view />
    </v-main>
  </v-app>
</template>

<script setup>
import { computed, ref, watch } from 'vue'
import { useRoute } from 'vue-router'
import { useStore } from 'vuex'
import { useTheme } from 'vuetify'
import Loader from '@/components/utils/Loader.vue'
import NavigationBar from '@/components/navigation/NavigationBar.vue'
import NavigationDrawer from '@/components/navigation/NavigationDrawer.vue'

const route = useRoute()
const showNav = computed(() => route.meta.requiresAuth)

const drawerOpen = ref(false)
const toggleDrawer = () => {
  drawerOpen.value = !drawerOpen.value
}
const closeDrawer = () => {
  drawerOpen.value = false
}

const store = useStore()
const theme = useTheme()
const isDarkMode = computed(() => store.state.theme?.darkMode || false)

watch(
  isDarkMode,
  (newVal) => {
    theme.global.name.value = newVal ? 'dark' : 'light'
  },
  { immediate: true }
)
</script>

<style>
:root {
  --safe-area-inset-top: 0px;
  --safe-area-inset-bottom: 0px;
  --safe-area-inset-left: 0px;
  --safe-area-inset-right: 0px;
  --app-safe-area-bottom: max(
    20px,
    env(safe-area-inset-bottom, 0px),
    var(--safe-area-inset-bottom, 0px)
  );
}

.safe-area-v-main {
  padding-top: calc(
    var(--v-layout-top, 0px) +
    max(env(safe-area-inset-top), var(--safe-area-inset-top, 0px))
  ) !important;
  padding-bottom: var(--app-safe-area-bottom, 20px) !important;
}

.safe-area-v-main .v-main__wrap {
  padding-bottom: calc(var(--v-layout-bottom, 0px) + var(--app-safe-area-bottom, 20px)) !important;
}

.safe-area-v-main .v-main__wrap > * {
  padding-bottom: var(--app-safe-area-bottom, 20px);
  box-sizing: border-box;
}
</style>
